<div class="container object-list">
    <p-messages></p-messages>
    <div class="header" *ngIf="!!header">
        <div class="label label-title">{{ header }}</div>
        <div class="total">Количество: {{ totalCount }}</div>
    </div>

    <div class="collection">
        <div class="item" *ngFor="let item of items">
            <app-card-object
               [application]="item"
               [isHotOffer]="true"
               [isBurn]="false"
               [isMobile]="isMobile$ | async"
               [isShowPrice]="true"
               (navigateToAnotherPageEvent)="navigateToDetailsPage($event)"
               [isLiked]="true">
            </app-card-object>
        </div>
    </div>
    <div class="footer" *ngIf="items && items.length && typeViewMore !== 'none'">
        <div class="button" *ngIf="typeViewMore === 'loadMore'">
            <app-button
               [disabled]="items.length >= totalCount"
               [text]="'Показать еще...'"
               [buttonClass]="'big-light-gray'"
               (buttonClick)="getMoreData()"
            ></app-button>
        </div>

        <div class="pagination" *ngIf="typeViewMore === 'pagination'">
            <p-paginator [rows]="paginationSettings.pageSize" #paginator  [totalRecords]="totalCount" (onPageChange)="changePage.emit($event)"></p-paginator>
        </div>
    </div>
</div>
